// src/utils/csvExport.js (or wherever your function is)

export const exportToCSV = (data, headers, filename) => {
  // Helper to safely format a value for CSV
  const formatValue = (value) => {
    if (value === null || value === undefined) {
      return ''; // Return empty string for null/undefined
    }
    const stringValue = String(value);
    // Escape double quotes by doubling them and wrap the whole string in quotes
    return `"${stringValue.replace(/"/g, '""')}"`;
  };

  // Create the header row
  const headerRow = headers.map(h => h.label).join(',');

  // Create the data rows
  const dataRows = data.map(item =>
    headers.map(header => formatValue(item[header.key])).join(',')
  );

  const csvContent = [headerRow, ...dataRows].join('\n');

  // Add a BOM for better Excel compatibility with UTF-8 characters
  const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
  const blobWithBom = new Blob([bom, csvContent], { type: 'text/csv;charset=utf-8;' });

  const url = URL.createObjectURL(blobWithBom);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};